<script>
  import options from './FileListCard.options'
  export default options
</script>

<template>
  <article class="kb-file-list-card">

    <a :href="cardData.activeActionLink" :target="activeActionTarget" alt="" class="kb-file-list-card__main-content kb-file-list-card--content-padding kb-js--file-link" @keydown.down="enterFunctions">
      <div class="kb-file-list-card__main-content-wrapper-left">
        <template v-if="cardData.svgIcon">
            <div class="kb-file-list-card__main-content-icon-wrapper">
                <div class="kb-file-list-card__main-content-icon-circle" v-html="cardData.svgIcon"></div>
            </div>
        </template>
        <div class="kb-file-list-card__main-content-text-wrapper">
          <p class="kb-file-list-card__main-content-text-label" v-if="cardData.updateDate">{{ getLabelOrEmpty('updateDate') }}{{ cardData.updateDate }}</p>
          <p class="kb-file-list-card__main-content-text-label" v-else-if="cardData.createdDate">{{ getLabelOrEmpty('updateDate') }}{{ cardData.createdDate }}</p>
          <h4 class="kb-file-list-card__main-content-text-file-name">{{cardData.name}}</h4>
        </div>
      </div>
      <div class="kb-file-list-card__main-content-wrapper kb-file-list-card__main-content-wrapper-right" v-if="cardData.createdBy">
        <div class="kb-file-list-card__main-content-text-wrapper kb-file-list-card__main-content-text-wrapper--right">
          <p class="kb-file-list-card__main-content-text-label kb-file-list-card__main-content-text-label--low-opacity"> {{ getLabel('createdTitle') }}</p>
          <p class="kb-file-list-card__main-content-text-created-by">
            {{cardData.createdBy}}
          </p>
        </div>
      </div>
      <span class="kb-visually-hidden">   {{ getLabel('helpTextMainLink') }}</span>
    </a>

    <div class="kb-file-list-card__secondary-content-wrapper kb-file-list-card--content-padding-last">
   
        <button tabindex="-1" 
          aria-haspopup="dialog"
          @click="(e) => determineStartOverlayFunction(e, 'CreateFolderOverlay', cardData)" 
          @keydown.esc="exitOnEscape" 
          class="kb-button kb-button--border-color kb-js--file-function">  
              {{ getLabel('renameButtonText') }}
              <p class="kb-visually-hidden">  {{ getLabel('helpTextOverlayButtonsAndDownloadLink') }}</p>
              <div class="kb-button__icon-wrapper" v-html="cardButtonIcons.renameIcon"></div>
          </button>
        <button tabindex="-1" 
          aria-haspopup="dialog"
          @click="(e) => determineStartOverlayFunction(e,  'ConfirmDeleteOverlay', cardData)" 
          @keydown.esc="exitOnEscape" 
          class="kb-button kb-button--border-color kb-js--file-function">  
              {{ getLabel('deleteButtonText') }}
              <p class="kb-visually-hidden">{{ getLabel('helpTextOverlayButtonsAndDownloadLink') }}</p>
              <div class="kb-button__icon-wrapper" v-html="cardButtonIcons.deleteIcon"></div>
          </button>
        <button tabindex="-1" 
          aria-haspopup="dialog"
          @click="(e) => determineStartOverlayFunction(e, 'MoveFileOverlay', cardData)" 
          @keydown.esc="exitOnEscape" 
          class="kb-button kb-button--border-color kb-js--file-function">  
              {{ getLabel('moveButtonText') }}
              <p class="kb-visually-hidden">{{ getLabel('helpTextOverlayButtonsAndDownloadLink') }}</p>
              <div class="kb-button__icon-wrapper" v-html="cardButtonIcons.moveIcon"></div>
          </button>
   
        <a :href="cardData.downloadLink" 
          tabindex="-1" 
          target="_blank"
          @keydown.esc="exitOnEscape" 
          class="kb-button kb-button--border-color kb-js--file-function">
            {{ getLabel('downloadButtonText') }}
            <p class="kb-visually-hidden">{{ getLabel('helpTextOverlayButtonsAndDownloadLink') }}</p>
            <div class="kb-button__icon-wrapper" v-html="cardButtonIcons.moveIcon"></div>
        </a>

    </div>
  </article>
</template>
